import BaseAPI from "../baseAPI"

class SubscriptionAPI extends BaseAPI {
  insertSubscription(data) {
    return this.post("/subscribers/create", data)
  }
}

export { SubscriptionAPI as default }